define('widgets/inputs/text/viewmodel',['widgets/inputs/AbstractInputWidget'], function (AbstractInputWidget) {

    /**
     * Usage:
     *
     *      <div data-bind="inputs.text: settings"></div>
     *
     * Settings:
     *      {core/FormFields.textField} field
     *      {Observable String} label
     *      {Boolean} autoFocus (Default: false)
     */
    function TextInputWidget() {
        AbstractInputWidget.call(this);
    }

    TextInputWidget.prototype = Object.create(AbstractInputWidget.prototype);

    return TextInputWidget;

});

